var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 4,
  fill: "#F7931E"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.087 6.464c-2.971 0-5.38 2.382-5.38 5.321 0 2.94 2.409 5.322 5.38 5.322 2.972 0 5.382-2.383 5.382-5.322s-2.41-5.321-5.382-5.321zm0 7.521c-1.228 0-2.224-.985-2.224-2.2 0-1.214.996-2.2 2.224-2.2 1.229 0 2.225.986 2.225 2.2 0 1.215-.996 2.2-2.225 2.2zM18.987 21.342c2.155-.434 3.446-1.442 3.514-1.497.63-.5.732-1.41.226-2.034a1.474 1.474 0 0 0-2.057-.223c-.013.01-1.39 1.055-3.655 1.056-2.266-.001-3.672-1.046-3.685-1.056-.63-.5-1.552-.4-2.057.223a1.436 1.436 0 0 0 .226 2.034c.07.055 1.413 1.09 3.628 1.514l-3.086 3.19a1.436 1.436 0 0 0 .037 2.046c.284.27.65.405 1.016.405.383 0 .766-.148 1.053-.442l2.868-3.02 3.157 3.04a1.475 1.475 0 0 0 2.069-.002 1.435 1.435 0 0 0-.002-2.046l-3.252-3.188z",
  fill: "#fff"
})));
export { SvgOk as ReactComponent };